import { formatCodeableConcept, type WithId } from '@medplum/core';
import type { CodeableConcept, ServiceRequest } from '@medplum/fhirtypes';

export type DetailSection = { title: string; value: string; preserveWhitespace?: boolean };

/** Format a list of CodeableConcepts as a comma-separated string of display names. */
export const joinFormattedConcepts = (concepts: CodeableConcept[] | undefined): string | null =>
  concepts
    ?.map((c) => formatCodeableConcept(c))
    .filter((text): text is string => Boolean(text))
    .join(', ') || null;

/** Pull the SR's reason: first try `reasonCode[]`, then fall back to `reasonReference[0].display`. */
export const getReason = (sr: WithId<ServiceRequest>): string | null =>
  joinFormattedConcepts(sr.reasonCode) || sr.reasonReference?.at(0)?.display || null;

/** Concatenate `note[].text` with newline separators. */
export const getNote = (sr: WithId<ServiceRequest>): string | null =>
  sr.note
    ?.map((n) => n.text)
    .filter((text): text is string => Boolean(text))
    .join('\n') || null;
